import { useState } from 'react';

import { Col, Row, Alert } from 'antd';
import NavigationTitle from '$src/components/NavigationTitle';
import AlertsPreferencesTable, { mergePreferences, usePreferences } from '$src/components/AlertsPreferencesTable';
import { CustomIcon } from '$src/components/CustomIcon';
import { sharedUsersUri } from '$src/utils/RapidSolutionsIntegrations/urls';
import { RvdAppIcon } from '@ring-icons';
import useStores from '$src/hooks/useStores';
import useLocationContext from '$src/hooks/useLocationContext';

import './index.less';

function Preferences() {
  const locationId = useLocationContext();
  const {
    preferencesStore: { putPreferences, contacts, alertPreferences, preferences },
    locationContextStore: { locationOwnerId },
  } = useStores();
  const [updating, setUpdating] = useState(false);
  const [fetchingPreferences, setFetchingPreferences] = useState(true);
  usePreferences(locationOwnerId, locationId, setFetchingPreferences);

  const handlePreferences = async (key, value, checked) => {
    setUpdating(true);
    const newPreferences = mergePreferences({ preferences, key, value, checked });
    await putPreferences(newPreferences, locationOwnerId, locationId);
    setUpdating(false);
  };

  return (
    <div className="preferences" data-testid="alert-preferences-page">
      <div>
        <NavigationTitle title="Alert Preferences" icon={RvdAppIcon} noMargin>
          For each event category, choose who should be alerted, and how.
        </NavigationTitle>
        <Alert
          className="preferences-alert"
          message="Each alert includes a link to a video of the event.  These video links can only be accessed by shared users and the account owner."
          description={
            <a target="_blank" href={sharedUsersUri()} rel="noreferrer">
              Manage Shared Users
            </a>
          }
          type="info"
          showIcon
          icon={<CustomIcon type="regular" name="info_outline.svg" />}
        />
      </div>
      <Row>
        <Col className="max-width" data-testid="preferences-section">
          <AlertsPreferencesTable
            updating={updating}
            loading={fetchingPreferences}
            updatePreferences={handlePreferences}
            putPreferences={handlePreferences}
            contacts={contacts}
            alertPreferences={alertPreferences}
          />
        </Col>
      </Row>
    </div>
  );
}

export default Preferences;
